import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import { FaTrophy, FaBolt, FaGem, FaShieldAlt } from 'react-icons/fa';
import SEO from '../components/SEO';
import { seoContent } from '../config/seoContent';
import { servicesData } from '../data/servicesData';
import './Services.css';
import './ServicesExtra.css';

const ServiceCard = ({ service, index }) => (
  <div className="service-row-card" data-aos="fade-up" data-aos-delay={index * 100}>
    <div className="service-row-image">
      <img src={service.image} alt={service.title} />
    </div>
    <div className="service-row-content">
      <h2>{service.title}</h2>
      <p>{service.shortDesc}</p>
    </div>
    <div className="service-row-action">
      <Link to={`/services/${service.id}`} className="btn btn-primary">Learn More</Link>
    </div>
  </div>
);

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const mainServices = servicesData.filter(s => s.category === 'services');
  const rentalServices = servicesData.filter(s => s.category === 'rentals');
  const materialServices = servicesData.filter(s => s.category === 'materials');

  return (
    <>
      <SEO
        title={seoContent.services.title}
        description={seoContent.services.description}
        keywords={seoContent.services.keywords}
      />

      <div className="page-header services-header" style={{backgroundImage: 'linear-gradient(135deg, rgba(46,125,50,0.85) 0%, rgba(25,118,210,0.85) 100%), url(/new_image/Excavator for rent.jpg)', backgroundSize: 'cover', backgroundPosition: 'center'}}>
        <div className="container">
          <h1 data-aos="fade-up">Our Services</h1>
          <p data-aos="fade-up" data-aos-delay="100">Comprehensive Civil Construction Solutions</p>
        </div>
      </div>

      {/* Main Services */}
      <section className="services-list">
        <div className="container">
          <div className="section-category-header" data-aos="fade-up">
            <h2>Our Services</h2>
            <p>Professional civil construction and demolition services in Coimbatore</p>
          </div>
          <div className="services-grid">
            {mainServices.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* Rental Services */}
      <section className="services-list rentals-list">
        <div className="container">
          <div className="section-category-header" data-aos="fade-up">
            <h2>Equipment for Rent</h2>
            <p>Heavy machinery and equipment rental services across Coimbatore</p>
          </div>
          <div className="services-grid">
            {rentalServices.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* Building Materials */}
      <section className="services-list materials-list">
        <div className="container">
          <div className="section-category-header" data-aos="fade-up">
            <h2>Building Materials</h2>
            <p>Quality construction materials supplied and delivered across Coimbatore</p>
          </div>
          <div className="services-grid">
            {materialServices.map((service, index) => (
              <ServiceCard key={service.id} service={service} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Our Services */}
      <section className="why-services-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2>Why Choose Our Services</h2>
            <p>Excellence in every aspect of civil construction</p>
          </div>
          <div className="why-services-grid">
            <div className="why-service-card" data-aos="flip-left">
              <div className="why-icon"><FaTrophy /></div>
              <h3>Proven Track Record</h3>
              <p>500+ successfully completed projects across Coimbatore with 100% client satisfaction rate.</p>
            </div>
            <div className="why-service-card" data-aos="flip-left" data-aos-delay="100">
              <div className="why-icon"><FaBolt /></div>
              <h3>Fast & Efficient</h3>
              <p>Modern equipment and streamlined processes ensure quick project completion without compromising quality.</p>
            </div>
            <div className="why-service-card" data-aos="flip-left" data-aos-delay="200">
              <div className="why-icon"><FaGem /></div>
              <h3>Premium Quality</h3>
              <p>Only the best materials and expert workmanship for long-lasting, durable results.</p>
            </div>
            <div className="why-service-card" data-aos="flip-left" data-aos-delay="300">
              <div className="why-icon"><FaShieldAlt /></div>
              <h3>Safety First</h3>
              <p>Comprehensive safety protocols and insurance coverage for complete peace of mind.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Service Guarantee */}
      <section className="guarantee-section">
        <div className="container">
          <div className="guarantee-content" data-aos="zoom-in">
            <h2>Our Service Guarantee</h2>
            <p className="guarantee-subtitle">We stand behind our work with confidence</p>
            <div className="guarantee-grid">
              <div className="guarantee-item">
                <span className="guarantee-number">100%</span>
                <p>Quality Assurance</p>
              </div>
              <div className="guarantee-item">
                <span className="guarantee-number">24/7</span>
                <p>Customer Support</p>
              </div>
              <div className="guarantee-item">
                <span className="guarantee-number">15+</span>
                <p>Years Experience</p>
              </div>
              <div className="guarantee-item">
                <span className="guarantee-number">300+</span>
                <p>Happy Clients</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
